<template>

    <div class="connection">
        <span class="icon"><i class="fas fa-bold"></i></span>        
        <span class="icon"><i class="fas fa-user-plus"></i></span>
        <span class="icon"><i class="fas fa-lock"></i></span>
        <span class="icon"><i class="fas fa-cog"></i></span>
    </div>

</template>

<script>
export default {
  
}
</script>


<style>

.connection {

    display: flex;
    justify-content: end;
    width:220px;

}

.icon {

    display: inline-block;
    margin-right: 20px;

}

</style>